import { Box, ButtonBase, Stack } from '@mui/material';

export interface FilterChip<K extends string> {
  key: K;
  label: string;
  count: number;
}

/** A row of counts that are also filters; the active one is filled. */
export function FilterChips<K extends string>({
  chips,
  value,
  onChange,
}: {
  chips: FilterChip<K>[];
  value: K;
  onChange: (key: K) => void;
}) {
  return (
    <Stack direction="row" spacing={1} flexWrap="wrap" useFlexGap>
      {chips.map((c) => {
        const active = value === c.key;
        return (
          <ButtonBase
            key={c.key}
            onClick={() => onChange(c.key)}
            aria-pressed={active}
            sx={{
              px: 1.75,
              py: 0.875,
              borderRadius: 999,
              gap: 1,
              border: 1,
              borderColor: active ? 'text.primary' : 'divider',
              bgcolor: active ? 'text.primary' : 'background.paper',
              color: active ? 'background.paper' : 'text.primary',
              fontSize: '0.875rem',
              fontWeight: 500,
              transition: 'background-color 150ms ease, color 150ms ease',
              '&:hover': { borderColor: 'text.primary' },
            }}
          >
            {c.label}
            <Box component="span" sx={{ fontWeight: 700, fontVariantNumeric: 'tabular-nums', opacity: active ? 1 : 0.7 }}>
              {c.count}
            </Box>
          </ButtonBase>
        );
      })}
    </Stack>
  );
}
